import moment from 'moment'
import api from '../../api/api'
const instance = {
  filters: [
    {
      name: 'formatDate',
      func: (value, format) => {
        return moment(value).format(format)
      }
    },
    {
      name: 'formatPrice',
      func: value => {
        var str = value.toFixed(2) + ''
        var intSum = str.substring(0, str.indexOf('.')).replace(/\B(?=(?:\d{3})+$)/g, ',')// 取到整数部分
        var dot = str.substring(str.length, str.indexOf('.'))// 取到小数部分搜索
        var ret = intSum + dot
        return ret
      }
    },
    {
      name: 'firstImageSrc',
      func: (value, separator = '|') => {
        const src = value.split(separator)[0]
        return api.formatImageUrl(src)
      }
    },
    {
      name: 'imageSrc',
      func: value => {
        return api.formatImageUrl(value)
      }
    },
    {
      name: 'imgUrlFilter',
      func: value => {
        value = value.split('|')[0]
        if (value.indexOf('http://') === 0 || value.indexOf('https://') === 0) {
          return value
        }
        const bashImageUrl = process.env.VUE_APP_BASH_IMAGE_URL
        if (value.indexOf('/') === 0) { return bashImageUrl + value.slice(1) }
        return bashImageUrl + value
      }
    },
    {
      name: 'stateStrFilter',
      func: value => {
        let stateStr = ''
        value = String(value)
        switch (value) {
          case '0' :
            stateStr = '发起交易'
            break
          case '1' :
            stateStr = '交易完成（关闭订单）'
            break
          case '20' :
            stateStr = '客户已付款 （等待发货）'
            break
          case '24' :
            stateStr = '客户未付款（等待买家付款）'
            break
          case '30' :
            stateStr = '已发货（未签收）'
            break
          case '34' :
            stateStr = '仓库退回'
            break
          case '40' :
            stateStr = '取消'
            break
          case '41' :
            stateStr = '买家取消'
            break
          case '42' :
            stateStr = '逾期取消'
            break
          case '43' :
            stateStr = '订单无效取消'
            break
          case '50' :
            stateStr = '客户签收'
            break
          case '54' :
            stateStr = '客户拒签'
            break
          default :
            stateStr = '未知状态' + value
        }
        return stateStr
      }
    }
  ]
}

instance.install = function (Vue) {
  for (const filter of this.filters) {
    Vue.filter(filter.name, filter.func)
  }
}

export default instance
